import { toast } from 'sonner';
import type { TFormSliderEvaluationSummary } from 'types/evaluation.types';
import { EEvaluationType, zMatrixSliderEvaluationWeighted } from 'types/evaluation.types';
import {
  hasNestedKeys,
  EFormType,
  type TFormSubType,
  isForm,
  type TFormQuestion,
  type TAvailableLanguageCodes,
} from '@hubertai/screening-question-types';

const evaluateForm = (question: TFormQuestion, language: TAvailableLanguageCodes, nodeEvaluation: any) => {
  const temp: TFormSliderEvaluationSummary = {
    id: question.id,
    evaluation: {},
    summary: {
      [EEvaluationType.Bonus]: 0,
      [EEvaluationType.Warning]: 0,
      [EEvaluationType.Disqualified]: 0,
      [EEvaluationType.Info]: 0,
      [EEvaluationType.Weighted]: 0,
    },
    isDefault: true,
  };

  if (!isForm(question)) {
    toast.error(`useQuestionEvaluation.evaluateForm - is not TFormQuestion.`);
  }

  function summarizeFormEvaluation(nodeEvaluation: any, form: TFormSubType) {
    const key = `${form.id}`;

    if (hasNestedKeys(nodeEvaluation, form.id, 'evaluation')) {
      const evaluation = nodeEvaluation[form.id].evaluation;

      if (!evaluation) return;

      if (Array.isArray(evaluation)) {
        let maxBonus = 0;
        evaluation.map((detail) => {
          if (detail.name === EEvaluationType.Info) {
            temp.summary[EEvaluationType.Info] += 1;
          }

          if (detail.name === EEvaluationType.Warning) {
            temp.summary[EEvaluationType.Warning] += 1;
          }

          if (detail.name === EEvaluationType.Bonus) {
            maxBonus = Math.max(maxBonus, detail.bonus_points ?? 0);
            /*
            temp.summary[EEvaluationType.Bonus] = Math.max(
              temp.summary[EEvaluationType.Bonus],
              detail.bonus_points ?? 0,
            );
            */
          }

          if (detail.name === EEvaluationType.Disqualified) {
            temp.summary[EEvaluationType.Disqualified] += 1;
          }
        });

        temp.summary[EEvaluationType.Bonus] += maxBonus;

        if (form.type === EFormType.Matrix) {
          temp.summary[EEvaluationType.Bonus] = temp.summary[EEvaluationType.Bonus] * form.rows.length;
        }
      } else {
        const x = zMatrixSliderEvaluationWeighted.safeParse(evaluation);
        if (x.success) {
          temp.summary[EEvaluationType.Weighted] += evaluation.weight;
        } else {
          toast.error(`evaluateForm - ${question.id}: Form evaluation is in unknown format, form: ${form.id}`);
          console.error(
            `evaluateForm - ${question.id}: Form evaluation is in unknown format, form: ${form.id}`,
            evaluation,
          );
        }
      }

      temp.evaluation[key] = evaluation;
      temp.isDefault = false;
    }
  }

  // Only evaluate forms that are enabled for the current language
  const forms = question.forms.filter((f) => language in f.enabled && f.enabled[language]);
  forms.map((form) => {
    summarizeFormEvaluation(nodeEvaluation, form);
  });

  return temp;
};

export default evaluateForm;
